import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(request: Request): Promise<Optional<ResponseData>> {
	const url = `${SERVICEBASEURL.BACKEND}/ErrorMessage/Search`;
	return axios.post<ResponseData>(url, request).toOptionalMapped((x) => x.data);
}

export interface Request {
	searchTerm: string | null;
	showOnlyDeleted: boolean;
	pageIndex: number | null;
	pageSize: number | null;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	data: ResponseErrorMessage[];
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	pageIndex: number;
	pageSize: number;
	totalCount: number;
	totalPages: number;
};

export type ResponseErrorMessage = {
	id: string;
	errorKey: string;
	errorMessage: string;
};
